<ion-button
  class="load-more-button"
  fill="outline"
  expand="block"
  [disabled]="loading()"
  (click)="clicked.emit()"
>
  @if (loading()) {
    Loading...
  } @else {
    Load more
  }
</ion-button>
